<app-offline-banner />
<app-session-expired-banner />
<router-outlet />